export default {
    contractSummary: {
        title: 'Sažetak ugovora',
        editContract: 'Uredi ugovor',
        newContract: '+ Novi ugovor',
        counterparty: 'Druga strana',
        profileSource: 'Izvor profila',
        tenor: 'Rok',
        delivery: 'Isporuka',
        totalVolume: 'Ukupni volumen',
        price: 'Cijena',
        version: 'Verzija',
    },
}
